import React from "react";
import { Helmet } from "react-helmet";
import { makeStyles } from "@material-ui/core/styles";
import LogoAprendro from "../images/logoaprendo.png";
import Mapa from "../images/mapa.png";
import Figuras from "../images/figuras.png";
import LogoLR from "../images/logolr.png";
import LogoFGML from "../images/logofgml.png";
import LogoMinedu from "../images/logominedu.png";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
// import clsx from "clsx"
import Banner from "../components/Banner";

const useStyles = makeStyles((theme) => ({
  title: {
    fontFamily: "Gotham Rounded",
    fontWeight: 600,
    fontSize: 80,
    textTransform: "uppercase",
    color: theme.palette.primary.main,
    textAlign: "center",
    lineHeight: 1,
    marginTop: 0,
    letterSpacing: -4,
    [theme.breakpoints.down("xs")]: {
      fontSize: 40,
    },
  },
  aprendo: {
    width: 180,
  },
  aprendoContainer: {
    width: "100%",
    textAlign: "center",
  },
  mapa: {
    padding: theme.spacing(1),
    textAlign: "center",
    "& img": {
      maxWidth: "100%",
      width: 500,
    },
  },
  lr: {
    width: 158,
  },
  fgml: {
    height: 70,
  },
  minedu: {
    width: 240,
  },
  logos: {
    "& img": {
      marginLeft: 5,
    },
    marginTop: "1em",
  },
  root: {
    minHeight: "90vh",
    height: "auto",
    marginTop: 36,
  },
  rootIndice: {
    minHeight: "90vh",
    height: "auto",
    margin: "2em 0",
  },
  divider: {
    borderTop: "10px solid " + theme.palette.primary.main,
    marginTop: theme.spacing(8),
  },
  nameIndice: {
    padding: "10px 20px 5px",
    background: theme.palette.primary.main,
    width: 130,
    fontSize: 35,
    color: "#fff",
    borderBottomRightRadius: 12,
    borderBottomLeftRadius: 12,
    marginLeft: theme.spacing(4),
    textTransform: "uppercase",
    textAlign: "center",
    fontWeight: 600,
    fontFamily: "Gotham Rounded",
  },
  nameLamina1: {
    fontSize: 20,
    maxWidth: 350,
    color: theme.palette.primary.main,
  },
  nameLamina2: {
    fontSize: 20,
    maxWidth: 300,
    color: theme.palette.blue.main,
  },
  nameLamina3: {
    fontSize: 20,
    maxWidth: 320,
    color: theme.palette.green.main,
  },
  nameLamina4: {
    fontSize: 20,
    maxWidth: 320,
    color: theme.palette.purple.main,
  },
  actions: {
    marginTop: theme.spacing(2),
    "& a": {
      marginRight: theme.spacing(1),
    },
  },
  actions2: {
    color: theme.palette.blue.main,
  },
  actions3: {
    color: theme.palette.green.main,
  },
  actions4: {
    color: theme.palette.purple.main,
  },
  indiceItem: {
    marginBottom: theme.spacing(4),
  },
  active: {
    "& a": {
      textDecoration: "none",
      color: "inherit",
    },
  },
  inactive: {
    color: theme.palette.grey[500],
  },
  figuras: {
    width: 300,
    maxWidth: "100%",
  },
  credits: {
    background: "#e6e7e8",
    padding: "1em",
    fontSize: 14,
    "& h3": {
      margin: 0,
    },
    "& p": {
      margin: 0,
    },
    marginBottom: theme.spacing(8),
  },
}));

const Home = () => {
  const classes = useStyles();
  return (
    <div>
      <Helmet
        title="Ciudadanía activa: índice"
        meta={[
          {
            property: "og:title",
            content: "Ciudadanía activa: índice",
            dataReactHelmet: true,
          },
          {
            property: "description",
            content:
              "Esta publicación forma parte del componente de Personal Social de la estrategia Aprendo en Casa y están dirigidas a estudiantes de educación primaria.",
            dataReactHelmet: true,
          },
        ]}
      />
      <Banner color="primary" />
      <Container maxWidth="lg">
        <Grid
          container
          className={classes.root}
          spacing={4}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={5} xs={12}>
            <div className={classes.aprendoContainer}>
              <img
                src={LogoAprendro}
                className={classes.aprendo}
                alt="Aprendo en casa"
              />
            </div>

            <h1 className={classes.title}>Ciudadanía activa</h1>
            <p>
              <strong>Ciudadanía activa</strong> es una publicación que forma
              parte de la estrategia Aprendo en Casa. Sus láminas abordan temas
              del área de Personal Social y están orientadas a afianzar la
              convivencia y la participación democrática, con ejemplos
              contextualizados en la coyuntura actual y actividades sencillas
              que favorecen aprendizajes significativos.
            </p>
            <p>
              Las láminas están disponibles para uso libre en la web y se
              presentan también en esta versión impresa gracias a una iniciativa
              de la{" "}
              <strong>
                Fundación Gustavo Mohme Llona y el Grupo La República
              </strong>
              . De esta manera, se suman a los esfuerzos emprendidos por
              nuestras autoridades para alcanzar una educación a distancia de
              calidad, porque hoy más que nunca necesitamos ciudadanos
              solidarios, con valores cívicos y comprometidos con el desarrollo
              del país, capaces de comprender nuestra sociedad y asumir los
              retos que enfrentamos.
            </p>
            <Button href="#indice" variant="outlined" color="primary">
              Ir al Índice
            </Button>
          </Grid>
          <Grid item lg={7} xs={12}>
            <div className={classes.mapa}>
              <img src={Mapa} alt="Ciudadanía Activa" />
            </div>
            <Grid
              container
              className={classes.logos}
              alignItems="center"
              justify="flex-end"
            >
              <img
                className={classes.lr}
                src={LogoLR}
                alt="Grupo La República"
              />
              <img
                className={classes.fgml}
                src={LogoFGML}
                alt="Fundación Gustavo Mohme Llona"
              />
              <img
                className={classes.minedu}
                src={LogoMinedu}
                alt="Ministerio de educación"
              />
            </Grid>
          </Grid>
        </Grid>
      </Container>
      <div className={classes.divider} id="indice">
        <div className={classes.nameIndice}>Índice</div>
      </div>
      <Container maxWidth="md">
        <Grid
          container
          className={classes.rootIndice}
          spacing={1}
          alignItems="center"
        >
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <div className={classes.indiceItem}>
              <h2 className={classes.nameLamina1}>
                Convivimos y nos cuidamos en nuestros espacios de ciudadanía
              </h2>
              <div className={classes.items}>
                <div className={classes.active}>
                  <a href="./lamina-1-1">
                    <strong>1.</strong> La familia{" "}
                    <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </div>
                <div className={classes.active}>
                  <a href="./lamina-1-2">
                    <strong>2.</strong> Deberes y rutinas en casa{" "}
                    <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </div>
                <div className={classes.active}>
                  <a href="./lamina-1-3">
                    <strong>3.</strong> La importancia de la escuela{" "}
                    <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </div>
                <div className={classes.active}>
                  <a href="./lamina-1-4">
                    <strong>4.</strong> Mi localidad{" "}
                    <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </div>
                <div className={classes.active}>
                  <a href="./lamina-1-5">
                    <strong>5.</strong> Las personas que nos cuidan{" "}
                    <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </div>
                <div className={classes.active}>
                  <a href="./lamina-1-6">
                    <strong>6.</strong> Perú, un territorio muy diverso{" "}
                    <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </div>
                <div className={classes.active}>
                  <a href="./lamina-1-7">
                    <strong>7.</strong> El campo y la ciudad{" "}
                    <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </div>
                <div className={classes.active}>
                  <a href="./lamina-1-8">
                    <strong>8.</strong> La dinámica de la ciudad{" "}
                    <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </div>
                <div className={classes.active}>
                  <a href="./lamina-1-9">
                    <strong>9.</strong> Recursos naturales del Perú{" "}
                    <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </div>
                <div className={classes.active}>
                  <a href="./lamina-1-10">
                    <strong>10.</strong> El cuidado del ambiente{" "}
                    <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </div>
                <div className={classes.active}>
                  <a href="./lamina-1-11">
                    <strong>11.</strong> Los medios de transporte{" "}
                    <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className={classes.indiceItem}>
              <h2 className={classes.nameLamina2}>
                Respetamos nuestros derechos y deberes para el bien de todos
              </h2>
              <div className={classes.items}>
                <div className={classes.active}>
                  <a href="./lamina-1-12">
                    <strong>12.</strong> Derechos y deberes de los ciudadanos{" "}
                    <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </div>
                <div className={classes.active}>
                  <a href="./lamina-1-13">
                    <strong>13.</strong> La identidad y la importancia del DNI{" "}
                    <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </div>
                <div className={classes.active}>
                  <a href="./lamina-1-14">
                    <strong>14.</strong> Derechos de los niños y las niñas{" "}
                    <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </div>
                <div className={classes.active}>
                  <a href="./lamina-1-15">
                    <strong>15.</strong> Normas de convivencia{" "}
                    <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </div>
                <div className={classes.active}>
                  <a href="./lamina-1-16">
                    <strong>16.</strong> Valores para la convivencia en familia{" "}
                    <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </div>
                <div className={classes.active}>
                  <a href="./lamina-1-17">
                    <strong>17.</strong> Emergencias, solidaridad y prevención{" "}
                    <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </div>
              </div>
            </div>
          </Grid>
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <img src={Figuras} className={classes.figuras} alt="Figuras" />
            <div className={classes.indiceItem}>
              <h2 className={classes.nameLamina3}>
                Vivimos la diversidad con justicia y equidad
              </h2>
              <div className={classes.items}>
                <div className={classes.active}>
                  <a href="./lamina-1-18">
                    <strong>18.</strong> Las distintas formas de ser peruano{" "}
                    <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </div>
                <div className={classes.active}>
                  <a href="./lamina-1-19">
                    <strong>19.</strong> En busca de la igualdad de
                    oportunidades{" "}
                    <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </div>
                <div className={classes.active}>
                  <a href="./lamina-1-20">
                    <strong>20.</strong> La equidad de género en el Perú{" "}
                    <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </div>
                <div className={classes.active}>
                  <a href="./lamina-1-21">
                    <strong>21.</strong> Las migraciones{" "}
                    <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </div>
                <div className={classes.active}>
                  <a href="./lamina-1-22">
                    <strong>22.</strong> Las lenguas del Perú{" "}
                    <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </div>
                <div className={classes.active}>
                  <a href="./lamina-1-23">
                    <strong>23.</strong> La importancia de cuidar nuestras
                    lenguas <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className={classes.indiceItem}>
              <h2 className={classes.nameLamina4}>
                Conocemos la organización de nuestro Estado
              </h2>
              <div className={classes.items}>
                <div className={classes.active}>
                  <a href="./lamina-1-24">
                    <strong>24.</strong> La democracia y las elecciones{" "}
                    <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </div>
                <div className={classes.active}>
                  <a href="./lamina-1-25">
                    <strong>25.</strong> Quiénes nos gobiernan{" "}
                    <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </div>
                <div className={classes.active}>
                  <a href="./lamina-1-26">
                    <strong>26.</strong> ¿Qué hace el congreso?{" "}
                    <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </div>
                <div className={classes.active}>
                  <a href="./lamina-1-27">
                    <strong>27.</strong> ¿Qué hace el Poder Judicial?{" "}
                    <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </div>
                <div className={classes.active}>
                  <a href="./lamina-1-28">
                    <strong>28.</strong> Los símbolos que representan al Perú{" "}
                    <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="lg" className={classes.credits} id="creditos">
        <h3>CIUDADANÍA ACTIVA</h3>
        <p>
          Es una adaptación de los textos Nuestro País del “Proyecto Democracia.
          Construyendo ciudadanía desde la escuela” de la Fundación Gustavo
          Mohme Llona, diseñado e implementado por el Instituto de Estudios
          Peruanos (IEP).{" "}
        </p>
        <p>
          <strong>Dirección:</strong> Stella Mohme Seminario /{" "}
          <strong>Textos originales:</strong> Carolina de Belaúnde, Mariana
          Eguren, Natalia González / <strong>Ilustraciones originales:</strong>
          Augusto Patiño.
        </p>
        <p>
          <strong>Edición:</strong> Ricardo Guerrero /{" "}
          <strong>Diseño, diagramación y adaptación de ilustración:</strong>{" "}
          Renzo Bravo / <strong>Cuidado de edición:</strong> Lérida Fernández.
        </p>
        <p>
          <strong>Reajuste del contenido pedagógico:</strong> Dirección de
          Educación Primaria (Ministerio de Educación del Perú).{" "}
          <strong>Validación para esta edición:</strong>
          Dirección General de Educación Básica Regular (Ministerio de Educación
          del Perú). Cedidos los derechos de esta edición a: © Grupo La
          República Publicaciones S. A., 2020 / Jr. Camaná 320, Lima 01, Perú /
          Teléfono: 711-6000.
        </p>
        <p>
          © Fundación Gustavo Mohme Llona / Av. Rivera Navarrete 788, piso 8,
          San Isidro / Teléfono: 4210999 / Web: fundaciónmohme.org
        </p>
        <p>
          Primera edición, junio de 2020 / Hecho el depósito legal en la
          Biblioteca Nacional del Perú n.° 15010195-0841 / Tiraje: 65 000 /
          Impreso en junio en los talleres gráficos de Ideprint S.A.C. - Jr.
          Ignacio Cossio 1605, La Victoria, Lima, Perú.
        </p>
        <p>
          Todos los derechos reservados. Permitida la reproducción de esta obra
          con fines pedagógicos y no comerciales siempre que se consignen los
          créditos de los autores y titulares de los derechos.
        </p>
      </Container>
    </div>
  );
};

export default Home;
